import type { Trip, TripList } from '@bambi/api-client/schemas';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';

import { getCancelReasonDisplay } from '../cancel/CancelTripModal/cancellationReasons';
import { TripStatusBadge } from 'src/features/trip/management/TripStatusBadge';

export const TripStatusCellContent = ({ trip }: { trip: TripList | Trip }) => {
  if (trip.status === 'canceled') {
    return (
      <SimpleTooltip
        trigger={
          <div className="cursor-pointer">
            <TripStatusBadge status={trip.status} />
          </div>
        }
        content={<div>{getCancelReasonDisplay(trip.canceled_reason)}</div>}
      />
    );
  }

  return <TripStatusBadge status={trip.status} />;
};
